<template>
  <div>
    <div
      v-if="show"
      tabindex="-1"
      class="overflow-y-auto overflow-x-hidden fixed top-1/3 right-0 left-0 z-50  h-modal "
    >
      <div class="relative p-4 w-full max-w-md h-full md:h-auto">
        <div class="relative bg-white rounded-lg shadow-lg dark:bg-gray-700">
        <div v-if="isModalLoader" class="w-full h-full absolute flex justify-center items-center  bg-loader z-5">
          <div class="spinner-border animate-spin inline-block w-8 h-8 border-4 rounded-full text-primary"
            role="status">
          </div>
        </div>
          <button
            type="button"
            @click="$setState('setDateRangeModal', false)"
            class="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white"
            data-modal-toggle="popup-modal"
          >
            <img class="2-5 h-5" :src="`${$getState('appUrl')}/img/pwa/modal-close.svg`" />
            <span class="sr-only">Close modal</span>
          </button>
          <div class="p-6 text-center">
            <div class="data-range mt-4 mb-5">
              <div class="mb-10">
                <span class="text-20 font-bold">Select Date Range</span>
              </div>
              <div class="text-left"> 
                <span class="text-14 text-text font-bold mb-2 text-left"> From: </span>
              </div>
              <div class="flex justify-between items-center">
                <Dropdown
                  class="mr-3"
                  v-model="from.year"
                  data-variable="years"
                  placeholder="Year"
                />
                <Dropdown
                  v-model="from.month"
                  data-variable="months"
                  placeholder="Month"
                />
              </div>
              <div class="text-left mt-4 mb-1"> 
                <span class="text-14 text-text font-bold mb-2 text-left"> To: </span>
              </div>
              <div class="flex justify-between items-center">
                <Dropdown
                  class="mr-3"
                  v-model="to.year"
                  :is-disabled="!isFrom"
                  data-variable="toYears"
                  :from-obj="from"
                  placeholder="Year"
                />
                <Dropdown
                  v-model="to.month"
                  :is-disabled="!isFrom"
                  data-variable="toMonths"
                  :from-obj="from"
                  :to-obj="to"
                  placeholder="Month"
                />
              </div>
              <div v-if="isData" class="mt-4">
                <span class="text-red-500 font-bold">No Donation Found</span>
              </div>
            </div>
            <div  class="text-center">
              <button
                data-modal-toggle="popup-modal"
                type="button"
                :disabled="!isActive"
                class="focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2"
                :class="downloadClass"
                @click="makeReport">
                Download
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Dropdown from '../UI/Dropdown.vue';

export default {
  name: 'DateRangeModal',
  components: {
    Dropdown
  },
  data () {
    return {
      from: {},
      to: {},
      isData: false,
      isModalLoader: false
    }
  },
  computed: {
    show() {
      return this.$getState("isDateRangeModal");
    },
    isFrom () {
      return this.from.year && this.from.month
    },
    isActive () {
      return this.from.year && this.from.month && this.to.year && this.to.month
    },
    downloadClass () {
      return {
        'text-white bg-btn-bg': this.isActive,
        'text-secondary bg-grey-1': !this.isActive
      }
    }
  },
  methods: {
    async makeReport () {
      this.isModalLoader = true
      const payload = {
        from_month: this.from.month,
        from_year: this.from.year,
        to_month: this.to.month,
        to_year: this.to.year
      }
      const { status } = await this.$http.post('/user/check-tax-report', payload)
      this.isData = !status
      this.isModalLoader = false
      if(status) {
        this.$emit('download', payload)
      }
    }
  },
  watch: {
    show (flag) {
      this.to = {}
      this.from = {}
      this.isData = false,
      this.$setState('setLoader', flag ? 1 : 0)
    }
  }
}
</script>